import React, { useState } from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { IAccount } from '../../../models/company-account';
import { IOrderDetails } from '../../../models/order';
import ConfirmBillingModal from './modals/confirm-billing-modal';
interface IBillingDropdownProps {
    billToAccounts: IAccount[];
    order: IOrderDetails;
}
export const BillingDropdown = ({
    billToAccounts,
    order,
}: IBillingDropdownProps) => {
    const [updatedBillTo, setUpdatedBillTo] = useState<IAccount>(
        billToAccounts[0]
    );
    const [selected, setSelected] = useState('option_1');
    const [confirmBillingModal, setConfirmBillingModal] = useState(false);
    const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelected(e.target.value);
        const account = billToAccounts.find(
            (account) => account.fullAccountNumber === e.target.value
        ) as IAccount;
        setUpdatedBillTo(account);
        setConfirmBillingModal(true);
    };
    return (
        <>
            <select
                className="form-control search-all-option"
                onChange={onChange}
                value={selected}
            >
                <option value="option_1" disabled hidden>
                    &#xf002; Search all addresses
                </option>
                {billToAccounts.map((option) => (
                    <option
                        key={option.fullAccountNumber}
                        value={option.fullAccountNumber}
                    >
                        {option.fullAccountNumber + ' ' + option.fullAddress}
                    </option>
                ))}
            </select>

            {confirmBillingModal && (
                <ConfirmBillingModal
                    updatedBillTo={updatedBillTo}
                    order={order}
                    onAccept={() => void 0}
                    onClose={() => {
                        setConfirmBillingModal(false);
                        setSelected('');
                    }}
                />
            )}
        </>
    );
};

export default BillingDropdown;
